// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"678":"ef6f6197","698":"7b2b09af","787":"2344a55e"}[chunkId] + ".chunk.js";
};